/* Skoleklær showcase, sections/skole-showcase.liquid: the colour dots on the
   garment cards and the name on the back. The rest of the page is plain HTML
   and works without this file.

   The name is fitted the way the shop's surname preview fits it
   (assets/surname-preview.js): the font size is the box's height, and a name
   wider than the box is shrunk to its width, never stretched, because the print
   is capped by width. Bebas Neue is fetched only once something uses it, so a
   name measured before it arrived would be measured in the wider fallback and
   come out too small; fonts.load asks for it up front and fits again when it is
   in (the same trap frostlinenorge.no's garment pages ran into). */
(function () {
  "use strict";

  function cards(root) {
    root.querySelectorAll("[data-card]").forEach(function (card) {
      card.addEventListener("click", function (event) {
        var dot = event.target.closest("[data-pick]");
        if (!dot) return;
        var key = dot.getAttribute("data-pick");
        card.querySelectorAll("[data-colour]").forEach(function (img) {
          img.classList.toggle("is-on", img.getAttribute("data-colour") === key);
        });
        card.querySelectorAll("[data-pick]").forEach(function (d) {
          d.setAttribute("aria-pressed", d === dot ? "true" : "false");
        });
      });
    });
  }

  function navn(root) {
    var section = root.querySelector("[data-navn]");
    if (!section) return;

    var backs = JSON.parse(section.querySelector("[data-navn-backs]").textContent);
    var frame = section.querySelector("[data-navn-frame]");
    var img = section.querySelector("[data-navn-img]");
    var box = section.querySelector("[data-navn-name]");
    var text = section.querySelector("[data-navn-text]");
    var input = section.querySelector("[data-navn-input]");
    var fallback = (input.defaultValue || "NORDMANN").toUpperCase();
    var state = { garment: "hoodie", colour: "navy" };

    function fit() {
      var b = backs[state.garment].box;
      box.style.left = b[0] + "%";
      box.style.top = b[1] + "%";
      box.style.width = b[2] + "%";
      box.style.height = b[3] + "%";

      var typed = input.value.trim().toUpperCase();
      text.textContent = typed || fallback;
      box.classList.toggle("is-placeholder", !typed);
      box.classList.toggle("is-dark", state.colour !== "navy");

      var side = frame.clientWidth;
      if (!side) return;
      var w = (side * b[2]) / 100;
      var h = (side * b[3]) / 100;
      text.style.fontSize = h + "px";
      var natural = text.offsetWidth;
      if (natural > w) text.style.fontSize = (h * w) / natural + "px";
    }

    function show() {
      var src = backs[state.garment][state.colour];
      if (img.getAttribute("src") === src) return fit();
      // Load the next back before swapping, so the name never sits on an empty frame.
      var next = new Image();
      next.onload = next.onerror = function () {
        img.src = src;
        fit();
      };
      next.src = src;
    }

    function press(selector, attr, value) {
      section.querySelectorAll(selector).forEach(function (el) {
        el.setAttribute("aria-pressed", el.getAttribute(attr) === value ? "true" : "false");
      });
    }

    section.addEventListener("click", function (event) {
      var garment = event.target.closest("[data-navn-garment]");
      var colour = event.target.closest("[data-navn-colour]");
      if (garment) {
        state.garment = garment.getAttribute("data-navn-garment");
        press("[data-navn-garment]", "data-navn-garment", state.garment);
        show();
      } else if (colour) {
        state.colour = colour.getAttribute("data-navn-colour");
        press("[data-navn-colour]", "data-navn-colour", state.colour);
        show();
      }
    });
    input.addEventListener("input", fit);

    if ("ResizeObserver" in window) new ResizeObserver(fit).observe(frame);
    else window.addEventListener("resize", fit);

    fit();
    if (document.fonts && document.fonts.load) {
      document.fonts.load('400 100px "Bebas Neue"').then(fit, fit);
      document.fonts.ready.then(fit);
    }

    // Warm the other five backs once the page is idle, so switching is instant.
    var warm = function () {
      Object.keys(backs).forEach(function (g) {
        ["gra", "navy"].forEach(function (c) {
          new Image().src = backs[g][c];
        });
      });
    };
    if ("requestIdleCallback" in window) window.requestIdleCallback(warm, { timeout: 4000 });
    else window.setTimeout(warm, 2500);
  }

  function init() {
    document.querySelectorAll(".sk").forEach(function (root) {
      cards(root);
      navn(root);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
